import { render, staticRenderFns } from "./FindPw.vue?vue&type=template&id=6d9a5c20&"
import script from "./FindPw.vue?vue&type=script&lang=js&"
export * from "./FindPw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports